module.exports = __webpack_public_path__ + "media/sparks.8119d262.ogg";